export type SymbolDetailSectionId = 'trend-chart' | 'symbol-info';

export const SYMBOL_DETAIL_SECTIONS: readonly SymbolDetailSectionId[] = ['trend-chart', 'symbol-info'];

export const SYMBOL_DETAIL_LAYOUT_STORAGE_KEY = 'kala-mobile-symbol-detail-layout';

export const SYMBOL_DETAIL_SECTION_LABELS: Record<SymbolDetailSectionId, string> = {
	'trend-chart': 'تغییرات روزانه',
	'symbol-info': 'اطلاعات تکمیلی'
};

export const SYMBOL_DETAIL_PINNED_SECTION_LABEL = 'تابلو';

export type SymbolDetailSectionExpansion = Record<SymbolDetailSectionId, boolean>;

export const DEFAULT_SYMBOL_DETAIL_EXPANSION: SymbolDetailSectionExpansion = {
	'trend-chart': true,
	'symbol-info': true
};

export interface SymbolDetailLayout {
	sectionOrder: SymbolDetailSectionId[];
	expanded: SymbolDetailSectionExpansion;
}

export const DEFAULT_SYMBOL_DETAIL_LAYOUT: SymbolDetailLayout = {
	sectionOrder: [...SYMBOL_DETAIL_SECTIONS],
	expanded: { ...DEFAULT_SYMBOL_DETAIL_EXPANSION }
};

export function pickSymbolDetailSectionOrder(stored?: unknown): SymbolDetailSectionId[] {
	const names = Array.isArray(stored) ? stored : [];
	const known = names.filter((id): id is SymbolDetailSectionId =>
		SYMBOL_DETAIL_SECTIONS.includes(id as SymbolDetailSectionId)
	);
	const ordered = [...new Set(known)];

	return [...ordered, ...SYMBOL_DETAIL_SECTIONS.filter(id => !ordered.includes(id))];
}

export function pickSymbolDetailExpansion(stored?: unknown): SymbolDetailSectionExpansion {
	const record = (stored ?? {}) as Partial<Record<SymbolDetailSectionId, unknown>>;

	return SYMBOL_DETAIL_SECTIONS.reduce<SymbolDetailSectionExpansion>(
		(expansion, section) => ({ ...expansion, [section]: record[section] !== false }),
		{ ...DEFAULT_SYMBOL_DETAIL_EXPANSION }
	);
}

export function pickSymbolDetailLayout(stored?: unknown): SymbolDetailLayout {
	const record = (stored ?? {}) as Partial<SymbolDetailLayout>;

	return {
		sectionOrder: pickSymbolDetailSectionOrder(record.sectionOrder),
		expanded: pickSymbolDetailExpansion(record.expanded)
	};
}
